module.exports = __webpack_public_path__ + "37315a86dbfde805b1413fd330c08d8f.png";